<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ul class="card-list-striped">

      <li><span class="text-secondary">Status </span><span>{{consulta?.status || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Código Fipe
        </span><span>{{consulta?.codigoFipe || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Vigência
        </span><span>{{consulta?.vigencia || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Ano modelo Fipe
        </span><span>{{consulta?.anoModeloFipe || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Modelo Fipe
        </span><span>{{consulta?.modeloFipe || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Fabricante Fipe
        </span><span>{{consulta?.fabricanteFipe || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Combustível Fipe
        </span><span>{{consulta?.combustivelFipe || "NÃO INFORMADO"}}</span></li>
      <li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || "NÃO INFORMADO"}}</span>
      </li>
      <li>
        <span class="text-secondary">Preço Fipe </span>
        <!--<span>{{(consulta?.precoFipe) ? (consulta?.precoFipe.replace(',', '') | currency: ' ') : "NÃO INFORMADO"}}</span>-->
        <span>{{(consulta?.precoFipe) ? ("R$ " + consulta?.precoFipe.replace("R$ ", "").replace("R$", "")) : "NÃO INFORMADO"}}</span>
      </li>
      <li>
        <span class="text-secondary">Preço Médio </span>
        <!--<span>{{(consulta?.precoMedio) ? (consulta?.precoMedio.replace(',', '') | currency: ' ') : "NÃO INFORMADO"}}</span>-->
        <span>{{(consulta?.precoMedio) ? ("R$ " + consulta?.precoMedio.replace("R$ ", "").replace("R$", "")) : "NÃO INFORMADO"}}</span>
      </li>
      <li>
        <span class="text-secondary">Preço Financeira </span>
        <span>{{(consulta?.precoFinanceira) ? ("R$ " + consulta?.precoFinanceira.replace("R$ ", "").replace("R$", "")) : "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Quantidade de registros
        </span><span>{{consulta?.quantidadeDeRegistros || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Versão
        </span><span>{{consulta?.versao || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Cambio
        </span><span>{{consulta?.cambio || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Potência
        </span><span>{{consulta?.potencia || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Acessório
        </span><span>{{consulta?.acessorio || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Portas
        </span><span>{{consulta?.portas || "NÃO INFORMADO"}}</span>
      </li>
      <li><span class="text-secondary">Configuração
        </span><span>{{consulta?.configuracao || "NÃO INFORMADO"}}</span>
      </li>

    </ul>

  </ng-container>

</app-card-consulta>
